import { React, observable, action, _, withStyles, StyledProps, classNames, Fragment } from '@api';
import { Tooltip2 } from '@api';
;
import { List, ListItem, ListItemText, ListItemSecondaryAction, Tooltip, Checkbox } from '@material-ui/core';
import { CentricTheme } from 'centric-ui-components'
import {observer} from 'mobx-react'

const styles = (theme: CentricTheme) => {
  return ({
    toggleText: {
      color: '#4184f3',
      fontSize: 13,
      cursor: 'pointer',
      paddingLeft: 24,
      height: 48,
      display: 'flex',
      alignItems: 'center'
    },
    toggleTextExpanded: {
      color: 'rgba(27, 27, 27, 0.54) !important'
    },
    itemRoot: {
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 12,
      paddingBottom: 12,
      height: 48
    },
    itemSecondaryAction: {
      right: -1
    },
    itemSecondaryActionCheckbox: {
      padding: 0,
      '& svg': {
        height: 22,
        width: 22
      }
    },
    listItem: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '95%'
    },
    primaryText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '95%',
      fontWeight: 'bold',
      paddingLeft: 24
    },
    secondaryText: {
      position: 'absolute',
      right: 3,
      display: 'inline-flex',
      fontSize: 12
    },
    hideSecondaryText: {
      display: 'none'
    },
    listRootWithoutTitle: {
      padding: 0
    },
    listRoot: {
      padding: 0
    },
    listItemTextRoot: {
      height: 48,
      display: 'flex',
      alignItems: 'center'
    }
  })
}

interface MyProps extends StyledProps {
  list: Array<any>,
  onClickListItem: (type, id, name, listItemDisplayKey, titleText, label?: string) => void,
  type: string,
  selectedItems: Array<any>,
  titleText?: string,
  listItemDisplayKey?: string
  customComparison?: boolean
}

@observer
export class ListCollapsibleComponent extends React.Component<MyProps> {
  @observable expanded = false

  static defaultProps = {
    list: [],
    onClickListItem: (type, id, name) => { },
    type: '',
    selectedItems: []
  }

  @action toggle = () => {
    this.expanded = !this.expanded
  }

  render() {
    const { expanded, props: { list, classes, onClickListItem, type, selectedItems, titleText, listItemDisplayKey, customComparison }} = this
    return (
      <Fragment>
        {titleText && <Tooltip2 content={`${titleText} (${list.length})` || ''}>
          <ListItemText classes={{root: classes.listItemTextRoot, primary: classes.primaryText, secondary: titleText ? classes.secondaryText : classes.hideSecondaryText}} primary={`${titleText} (${list.length})`} />
        </Tooltip2>
        }
        <List classes={{root: titleText ? classes.listRoot : classes.listRootWithoutTitle}}>
          {(expanded ? list : _.slice(list, 0, 3)).map((item, index) => {
            return (<Tooltip2 content={item.label ? item.label : (listItemDisplayKey ? item[listItemDisplayKey] || '' : item.name || '')} key={item.id}>
              <ListItem classes={{root: classes.itemRoot}} dense button onClick={() => onClickListItem(type, item.id, listItemDisplayKey ? item[listItemDisplayKey] : item.name, listItemDisplayKey, titleText, item.label)}>
                <Checkbox
                  classes={{root: classes.itemSecondaryActionCheckbox}}
                  checked={customComparison 
                    ? _.some(selectedItems, thisSelectedItem => (thisSelectedItem.type === item.name && thisSelectedItem.name === item[thisSelectedItem.customAttributeType]))
                    : _.some(selectedItems, { id: item.id })}
                />
                <ListItemText classes={{primary: classes.listItem}} primary={item.label ? item.label : (listItemDisplayKey ? item[listItemDisplayKey] : item.name)} />
              </ListItem>
            </Tooltip2>
            )
          }
          )}
        </List>
        {list.length > 3 && <div className={classNames(classes.toggleText, {[classes.toggleTextExpanded] : expanded})} onClick={this.toggle}>
          {expanded ? 'Show less' : 'Show all'}
        </div>}
      </Fragment>
    )
  }
}

@(withStyles as any)(styles)
export class ListCollapsible extends ListCollapsibleComponent {
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/ListCollapsible.tsx